<ng-container *transloco="let t">

  <button type="button" class="btn btn-outline-dark float-end" (click)="downloadCertificates()" [disabled]="download">
    <span *ngIf="!download"><i class="fa-solid fa-download"></i> {{ t('Download Certificates') }}</span>
    <span *ngIf="download"><i class="fa-solid fa-spinner fa-spin"></i> {{ t('Please wait...') }}</span>
  </button>

  <h2>{{ t('Certificates') }} {{ t('for') }} {{month}}</h2>

  <ng-container *ngIf="!certificates"><img src="/assets/images/loading1.gif" title="Loading" ></ng-container>

  <div *ngIf="certificates">
    <c-row>
      <c-col>
        <c-card  *ngIf="certificates.company.length > 0">
          <c-card-header>
            <h6>{{ t('Company Certificates') }}</h6>
          </c-card-header>
          <c-card-body>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4"  *ngFor="let companycert of certificates.company">
                <img src="{{companycert.img_url}}" class="img-fluid">
              </div>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
    <c-row>
      <c-col>
        <c-card  *ngIf="certificates.workers.length > 0">
          <c-card-header>
            <h6>{{ t('Worker Certificates') }}</h6>
          </c-card-header>
          <c-card-body>
            <div class="row">
              <div class="col-12 col-md-6 col-lg-4"  *ngFor="let workercert of certificates.workers">
                <img src="{{workercert.img_url}}" class="img-fluid">
              </div>
            </div>
          </c-card-body>
        </c-card>
      </c-col>
    </c-row>
</div>

</ng-container>
